<template>
  <div class="header d-flex align-items-center py-5">
    <div class="header-content w-100 shadow py-5">
      <div class="overlay"></div>
    
      <b-container class="content">
        <b-row class="">
          <b-col cols="12" md="8">
            <b-img 
              src="@/assets/logos/logo.svg" 
              alt="KILX: Stratégies d'affaires numériques" 
              class="logo mb-3" 
            /> 

            <h1 class="slogan bold display-5 text-white">Blogue <span class="blinking-cursor white">_</span></h1>

            <h2 class="display-5 m-0 text-blue">
              Stratégies, expertise et savoir-faire<br>pour une transformation numérique réussie.
            </h2>          
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {}
}
</script>

<style scoped>

.header-content {
  position: relative;
  background: url("../assets/images/code.jpg") no-repeat center fixed;
  background-size: cover;
  position: relative;
  z-index: 10;
}

.header-content,
.header-content > .content {
  position: relative;
  z-index: 10;
}

.overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0,0,0,0.9);
}

.header-subtitle {
  font-weight: normal;
}

.header-content-title {
    width: 100%;
}
</style>
